import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { defaultConfig, sites } from './constants';

export function getRoutingConfig(nodeId?: string) {
  const siteConfig = nodeId && sites[nodeId] ? sites[nodeId] : defaultConfig;

  return defineRouting({
    localePrefix: siteConfig.localePrefix,
    locales: siteConfig.locales,
    defaultLocale: siteConfig.defaultLocale,
  });
}

export const initConfig = getRoutingConfig();

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(initConfig);
